// ==============================|| OVERRIDES - SNACKBAR ||============================== //

export default function Snackbar(theme) {
    return {
        MuiSnackbar: {
            styleOverrides: {
                root: {
                    '&.MuiSnackbar-anchorOriginTopCenter': {
                        top: '24px',
                        zIndex: theme.zIndex.modal + 1
                    }
                }
            }
        }
    };
}
